/**
 * /admin/support — Admin help report inbox.
 *
 * Layout follows the same pattern as the other admin pages (page-shell +
 * PageHeader + section) — previously this page used ad-hoc `admin-page*`
 * classes that had no CSS, which made it look broken next to the rest of
 * the admin area. Auth-gated to admins like every other /admin route.
 */

import type { JSX } from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { PageHeader } from '../../../components/ui/PageHeader.js';
import { SupportInboxTable } from '../../../components/admin/SupportInboxTable.js';
import { freshSessionQuery } from '../../../lib/api/queries.js';

export const Route = createFileRoute('/admin/support/')({
  beforeLoad: async ({ context, location }) => {
    const session = await context.queryClient.fetchQuery(freshSessionQuery);
    const user = session?.ok ? (session.data?.user ?? null) : null;
    if (!user) {
      throw redirect({
        to: '/login',
        search: { error: undefined, redirect: location.href },
      });
    }
    if (user.role !== 'admin') {
      throw redirect({ to: '/' });
    }
    return null;
  },
  component: AdminSupportPage,
});

function AdminSupportPage(): JSX.Element {
  return (
    <main className="page-shell" data-testid="admin-support-page">
      <PageHeader
        eyebrow="Bantuan & support"
        title="Inbox laporan"
        description="Laporan masalah dan masukan dari semua user. Buka laporan untuk membalas atau mengubah statusnya."
      />
      <section className="section is-flush">
        <SupportInboxTable />
      </section>
    </main>
  );
}
